var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSaveDisk = function SvgSaveDisk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 151,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.096 54.12V28.322l-1.29-7.81a12.024 12.024 0 0 0-13.52-9.952l-8.062 1.113A6.704 6.704 0 0 0 1 18.36v118.156c0 9.996 16.188 13.489 16.514 13.469a.323.323 0 0 0 .132-.038l12.112-.81a.251.251 0 0 1 .11-.035v-3.87l.228-91.114Z",
    fill: "#ABB2BC",
    stroke: "#ABB2BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m114.206 8.11-3.263.219V48.45a3.222 3.222 0 0 1-3.002 3.224l-74.62 5.199a3.225 3.225 0 0 1-3.45-3.225v-33.84a5.421 5.421 0 0 0-5.805-5.411l-7.394.516a6.45 6.45 0 0 0-6.001 6.45v122.215a6.448 6.448 0 0 0 6.914 6.404l116.234-8.313a6.445 6.445 0 0 0 5.991-6.449V31.456a6.443 6.443 0 0 0-2.125-4.782L118.982 9.761a6.45 6.45 0 0 0-4.776-1.651Z",
    fill: "#EAECEE",
    stroke: "#ABB2BC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.867 63.333a3.224 3.224 0 0 0 3.45 3.224l74.624-5.214a3.222 3.222 0 0 0 3.002-3.225v-9.674a3.222 3.222 0 0 1-3.002 3.225l-74.62 5.204a3.225 3.225 0 0 1-3.45-3.224l-.003 9.684ZM16.675 24.588l7.395-.516a5.42 5.42 0 0 1 5.804 5.41V19.81a5.42 5.42 0 0 0-5.804-5.411l-7.395.516a6.45 6.45 0 0 0-6 6.45v9.673a6.45 6.45 0 0 1 6-6.45Zm121.01 2.086L118.982 9.761a6.455 6.455 0 0 0-4.773-1.651l-3.266.219v9.674l3.263-.229a6.45 6.45 0 0 1 4.773 1.651l18.703 16.914a6.444 6.444 0 0 1 2.125 4.782v-9.674a6.451 6.451 0 0 0-2.122-4.773Z",
    fill: "#F4F5F7",
    stroke: "#ABB2BC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m114.206 8.11-3.263.219V48.45a3.222 3.222 0 0 1-3.002 3.224l-74.62 5.199a3.224 3.224 0 0 1-3.45-3.225v-33.84a5.421 5.421 0 0 0-5.805-5.411l-7.394.516a6.45 6.45 0 0 0-6.001 6.45v122.215a6.448 6.448 0 0 0 6.914 6.404l116.234-8.313a6.445 6.445 0 0 0 5.991-6.449V31.456a6.443 6.443 0 0 0-2.125-4.782L118.982 9.761a6.45 6.45 0 0 0-4.776-1.651v0Z",
    stroke: "#ABB2BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m110.943 14.778-81.076 5.666v33.214a3.226 3.226 0 0 0 3.45 3.225l74.623-5.214a3.223 3.223 0 0 0 3.003-3.225V14.778Z",
    fill: "#ABB2BC",
    stroke: "#ABB2BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M110.917 8.329a3.225 3.225 0 0 0-3.418-3.012L52.444 8.745a3.225 3.225 0 0 0-3 3.225v7.107l6.45-.448v36.67l52.047-3.63a3.223 3.223 0 0 0 3.002-3.225l-.026-40.115Z",
    fill: "#F4F5F7",
    stroke: "#ABB2BC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m52.444 15.194 55.045-3.418a3.224 3.224 0 0 1 3.418 3.012l.02 33.824v-.162l-.01-40.121a3.225 3.225 0 0 0-3.418-3.012L52.444 8.745a3.225 3.225 0 0 0-3 3.225v6.449a3.225 3.225 0 0 1 3-3.225Z",
    fill: "#fff",
    stroke: "#ABB2BC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M110.917 8.329a3.225 3.225 0 0 0-3.418-3.012L52.444 8.745a3.225 3.225 0 0 0-3 3.225v7.107l6.45-.448v36.67l52.047-3.63a3.223 3.223 0 0 0 3.002-3.225l-.026-40.115Z",
    stroke: "#ABB2BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.47 8.742a3.225 3.225 0 0 0-3.025 3.224v7.11l6.449-.447v-6.67a3.226 3.226 0 0 0-3.425-3.217v0Z",
    fill: "#F4F5F7",
    stroke: "#ABB2BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m29.867 149.103 90.75-6.488V82.919a6.463 6.463 0 0 0-2.029-4.709 6.455 6.455 0 0 0-4.824-1.74l-77.847 4.837a6.45 6.45 0 0 0-6.05 6.45v61.346Z",
    fill: "#fff",
    stroke: "#ABB2BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M113.764 76.483 35.917 81.32a6.45 6.45 0 0 0-6.05 6.45v12.959l90.75-6.488V82.92a6.446 6.446 0 0 0-2.034-4.7 6.449 6.449 0 0 0-4.819-1.736Z",
    fill: "#D5D9DE",
    stroke: "#ABB2BC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M113.764 76.483 35.917 81.32a6.45 6.45 0 0 0-6.05 6.45v9.673a6.45 6.45 0 0 1 6.05-6.449l77.847-4.837a6.443 6.443 0 0 1 4.824 1.74 6.45 6.45 0 0 1 2.029 4.71v-9.675a6.463 6.463 0 0 0-2.029-4.709 6.456 6.456 0 0 0-4.824-1.74Z",
    fill: "#ABB2BC",
    stroke: "#ABB2BC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M113.764 76.483 35.917 81.32a6.45 6.45 0 0 0-6.05 6.45v12.959l90.75-6.488V82.92a6.446 6.446 0 0 0-2.034-4.7 6.449 6.449 0 0 0-4.819-1.736v0Z",
    stroke: "#ABB2BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m44.524 112.583 61.185-4.372Zm0 12.535 61.185-4.376Zm0 12.899 61.185-4.376Z",
    fill: "#D5D9DE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m44.524 112.583 61.185-4.372m-61.185 16.907 61.185-4.376m-61.185 17.275 61.185-4.376",
    stroke: "#ABB2BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.18064 1.26286 -.57544 .0415 81.928 27.433)",
    stroke: "#ABB2BC",
    strokeWidth: 1.992,
    strokeLinecap: "round",
    d: "M.996-.996h3.091"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.18064 1.26286 -.57544 .0415 88.744 26.643)",
    stroke: "#ABB2BC",
    strokeWidth: 1.992,
    strokeLinecap: "round",
    d: "M.996-.996h3.091"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M77.491 34.646c.6 1.412.056 2.9-1.211 3.327-1.268.428-2.781-.365-3.381-1.778-.6-1.412-.056-2.9 1.211-3.327 1.268-.428 2.781.366 3.381 1.778ZM99.918 30.127c.601 1.412.056 2.9-1.211 3.327-1.268.427-2.781-.366-3.381-1.778-.6-1.412-.056-2.9 1.211-3.327 1.268-.428 2.781.365 3.381 1.777Z",
    fill: "#D5D9DE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M94.02 34.703c.524 4.195-2.185 7.593-6.05 7.59-3.864-.003-7.42-3.407-7.944-7.602",
    stroke: "#ABB2BC",
    strokeWidth: 1.992,
    strokeLinecap: "round"
  })));
};

export default SvgSaveDisk;